export default __webpack_public_path__ + "static/media/benefit_1@2x.50a51e44.png";